/* bb-lp.js — landing-page buy buttons, quantity stepper + sticky bar.

   Any [data-bb-lp-buy] button adds its product + free gifts through the shared
   window.BBCart.addBundle (assets/bb-cart-add.js, the same sequence the PDP and
   homepage quick-add use, so the Tracker / scoop / eBook ride along), then goes
   STRAIGHT TO CHECKOUT (Dustin 2026-10-05: one page, one decision, no drawer).
   The add is silent (the drawer never slides out on the way), and the $1.99
   shipping protection line is added or removed per snippets/bb-lp-buy.liquid.

   Quantity (Dustin 2026-10-25): the offer box stepper ([data-bb-lp-qty], 1-10)
   sets ONE page-wide quantity. Prices ([data-bb-lp-now] × data-unit + data-extra),
   the savings and every buy button's label follow it. A buy sets the cart to
   exactly that many (Back from checkout + a second click never stacks), then
   scales the scoop + tracker to the kit count the way the cart drawer's sweep
   does (sections/bb-cart-drawer.liquid → getScalingGiftAdjustments); the eBook
   stays at 1. The drawer and PDP code is untouched: its helpers are copied here.

   [data-bb-lp-sticky] is the mobile buy bar. It stays hidden until the reader
   has scrolled PAST the offer box ([data-bb-lp-offer]), and hides again while
   the offer box is on screen. Nothing with a price shows above the offer. */

(function () {
  'use strict';
  if (window.__bbLpInit) return; // loaded by more than one section
  window.__bbLpInit = true;

  var MAX_QTY = 10;
  // Same IDs as the cart drawer's SCALING GIFTS block (verified there 2026-06-05).
  var SCALING_GIFT_VARIANT_IDS = [56989680599343, 54306317107503]; // scoop, printed tracker
  var KIT_PRODUCT_IDS = [10587258847535];                           // 4-Stage Detox Kit & Free Binder
  var qty = 1;

  function parseGifts(raw) {
    try {
      var arr = JSON.parse(raw || '[]');
      return Array.isArray(arr) ? arr.map(Number).filter(function (n) { return n > 0; }) : [];
    } catch (e) { return []; }
  }

  function showError(btn, msg) {
    var holder = btn.parentNode.querySelector('[data-bb-lp-err]');
    if (holder) { holder.textContent = msg; holder.hidden = false; }
  }

  function fmt(cents) {
    var d = cents / 100;
    return '$' + (cents % 100 === 0 ? d.toLocaleString('en-US')
      : d.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  function cartPost(path, body) {
    return fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function variantTotal(cart, variantId) {
    return (cart.items || []).reduce(function (n, it) { return n + (it.variant_id === variantId ? it.quantity : 0); }, 0);
  }

  // Set a kit variant's TOTAL cart quantity, verified against a fresh read (copy of
  // bb-cart-add.js setVariantTotalVerified: Simple Bundles kit lines only take
  // /cart/update.js reliably).
  function setVariantTotal(variantId, target, attempts, ask) {
    attempts = attempts === undefined ? 3 : attempts;
    if (ask === undefined) ask = target;
    var updates = {};
    updates[variantId] = ask;
    return cartPost('/cart/update.js', { updates: updates })
      .then(function () { return new Promise(function (res) { setTimeout(res, 600); }); })
      .then(getCart)
      .then(function (cart) {
        var total = variantTotal(cart, variantId);
        if (total === target) return cart;
        if (attempts <= 1) throw new Error('Could not update the quantity. Please try again.');
        return setVariantTotal(variantId, target, attempts - 1, total > target ? Math.max(0, ask - (total - target)) : target);
      });
  }

  // Scoop + tracker = total kits in the cart (1 when no kit), one change at a time
  // from a fresh read, exactly like the drawer's sweep step 2.
  function scaleGifts(rounds) {
    rounds = rounds === undefined ? 6 : rounds;
    return getCart().then(function (cart) {
      var kits = (cart.items || []).reduce(function (n, it) {
        return n + (KIT_PRODUCT_IDS.indexOf(it.product_id) !== -1 ? it.quantity : 0);
      }, 0);
      var target = kits > 0 ? kits : 1;
      var line = (cart.items || []).filter(function (it) {
        return SCALING_GIFT_VARIANT_IDS.indexOf(it.variant_id) !== -1 && it.quantity !== target;
      })[0];
      if (!line || rounds <= 0) return null;
      return cartPost('/cart/change.js', { id: line.key, quantity: target }).then(function () { return scaleGifts(rounds - 1); });
    });
  }

  // Shipping protection, same line the cart drawer adds (_bb_shipguard): the main
  // button (data-protect) makes sure one is in the cart; "Checkout without
  // protection" (data-skip-protect) takes any out. Never blocks the checkout.
  function syncProtection(addId, dropId) {
    var id = addId || dropId;
    if (!id) return Promise.resolve();
    return getCart()
      .then(function (cart) {
        var lines = (cart.items || []).filter(function (it) { return it.variant_id === id; });
        if (addId) {
          return lines.length ? null : cartPost('/cart/add.js', { items: [{ id: addId, quantity: 1, properties: { _bb_shipguard: '1' } }] });
        }
        return lines.reduce(function (p, it) {
          return p.then(function () { return cartPost('/cart/change.js', { id: it.key, quantity: 0 }); });
        }, Promise.resolve());
      })
      .catch(function () {});
  }

  function buy(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var holder = btn.parentNode.querySelector('[data-bb-lp-err]');
    if (holder) holder.hidden = true;
    if (!window.BBCart || !window.BBCart.addBundle) {
      showError(btn, 'Something went wrong. Please refresh and try again.');
      return;
    }
    var label = btn.innerHTML;
    btn.setAttribute('data-bb-label', label);
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Heading to checkout…';
    var want = qty;
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    var bundleId = btn.getAttribute('data-bundle-id');
    getCart().then(function (cart) {
      var inCart = (cart.items || []).some(function (it) {
        var props = it.properties || {};
        return it.variant_id === variantId && props._bb_bundle_id === bundleId;
      });
      // Already in the cart (Back from checkout, then a click): set it to the
      // number picked now; never add on top.
      if (inCart) return variantTotal(cart, variantId) === want ? null : setVariantTotal(variantId, want);
      return window.BBCart.addBundle({
        variantId: variantId,
        bundleId: bundleId,
        qty: want,
        giftIds: parseGifts(btn.getAttribute('data-gifts')),
        properties: { _bb_lp: btn.getAttribute('data-lp') || '' },
        silent: true // we're leaving for checkout: don't slide the cart drawer out (it flashed white)
      });
    }).then(function () {
      return scaleGifts();
    }).then(function () {
      return syncProtection(parseInt(btn.getAttribute('data-protect'), 10) || 0,
                            parseInt(btn.getAttribute('data-skip-protect'), 10) || 0);
    }).then(function () {
      window.location.href = '/checkout';
    }).catch(function (err) {
      btn.removeAttribute('aria-busy');
      btn.innerHTML = label;
      var msg = (err && err.shopify && err.shopify.description) || (err && err.message && err.message.indexOf('quantity') !== -1 && err.message) || 'We couldn’t add that to your cart. Please try again.';
      showError(btn, msg);
    });
  }

  // ── Quantity: one number for the whole page ────────────────────────────────
  function render() {
    document.querySelectorAll('[data-bb-lp-qty]').forEach(function (q) {
      var input = q.querySelector('[data-bb-lp-qty-input]');
      if (input && document.activeElement !== input) { input.value = qty; input.defaultValue = String(qty); }
      q.querySelector('[data-bb-lp-qty-dec]').setAttribute('aria-disabled', qty <= 1 ? 'true' : 'false');
      q.querySelector('[data-bb-lp-qty-inc]').setAttribute('aria-disabled', qty >= MAX_QTY ? 'true' : 'false');
    });
    document.querySelectorAll('[data-bb-lp-now]').forEach(function (el) {
      el.textContent = fmt(parseInt(el.getAttribute('data-unit'), 10) * qty + (parseInt(el.getAttribute('data-extra'), 10) || 0));
    });
    document.querySelectorAll('[data-bb-lp-each]').forEach(function (el) {
      el.hidden = qty < 2;
      el.textContent = qty + ' × ' + fmt(parseInt(el.getAttribute('data-unit'), 10)) + ' each';
    });
    document.querySelectorAll('[data-bb-lp-buy][data-unit]').forEach(function (btn) {
      var main = btn.querySelector('.bb-lp-buy__main');
      if (!main || btn.getAttribute('aria-busy') === 'true') return;
      var tpl = btn.getAttribute(qty > 1 ? 'data-label-multi-tpl' : 'data-label-tpl') || '';
      var total = parseInt(btn.getAttribute('data-unit'), 10) * qty + (parseInt(btn.getAttribute('data-extra'), 10) || 0);
      main.textContent = tpl.replace(/\[price\]/g, fmt(total)).replace(/\[qty\]/g, qty);
    });
  }

  function setQty(n) {
    n = parseInt(n, 10);
    if (!isFinite(n) || n < 1) n = 1;
    qty = Math.min(MAX_QTY, n);
    render();
  }

  // Typed quantity, same behavior as the cart drawer's input: digits only, cleared
  // on focus (old number shown as the placeholder) so typing REPLACES it, Enter
  // commits, Escape or an empty field keeps the old number.
  function initQty() {
    document.querySelectorAll('[data-bb-lp-qty]').forEach(function (q) {
      var input = q.querySelector('[data-bb-lp-qty-input]');
      q.querySelector('[data-bb-lp-qty-dec]').addEventListener('click', function () { setQty(qty - 1); });
      q.querySelector('[data-bb-lp-qty-inc]').addEventListener('click', function () { setQty(qty + 1); });
      if (!input) return;
      input.addEventListener('input', function () {
        var clean = input.value.replace(/\D+/g, '').slice(0, 2);
        if (clean !== input.value) input.value = clean;
      });
      input.addEventListener('focus', function () {
        input.placeholder = input.defaultValue;
        input.value = '';
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault(); input.blur();
        } else if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
          input.value = ''; input.blur();
        }
      });
      input.addEventListener('blur', function () {
        var typed = parseInt(input.value, 10);
        input.placeholder = '';
        if (isFinite(typed) && typed > 0) setQty(typed);
        else { input.value = qty; render(); }
      });
    });
    render();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bb-lp-buy]');
    if (!btn) return;
    e.preventDefault();
    buy(btn);
  });

  // Back from checkout restores the page from the bfcache with the button still
  // saying "Heading to checkout…": put the label back.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-bb-lp-buy][aria-busy="true"]').forEach(function (btn) {
      btn.removeAttribute('aria-busy');
      if (btn.hasAttribute('data-bb-label')) btn.innerHTML = btn.getAttribute('data-bb-label');
    });
    render();
  });

  function initSticky() {
    var bar = document.querySelector('[data-bb-lp-sticky]');
    var offer = document.querySelector('[data-bb-lp-offer]');
    if (!bar || !offer || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var en = entries[0];
      var passed = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
    });
    io.observe(offer);
  }

  function init() { initQty(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
